import { render, staticRenderFns } from "./userTopNav.vue?vue&type=template&id=0be39524&"
import script from "./userTopNav.vue?vue&type=script&lang=js&"
export * from "./userTopNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports